import React from 'react'
import { LuBuilding2, LuGlobe } from 'react-icons/lu'

import useAppDispatch from '@/hooks/useAppDispatch'
import useAppSelector from '@/hooks/useAppSelector'
import { REFERRAL_SOURCE } from '@/lib/constants'
import { cn } from '@/lib/utils'
import {
  selectReferralSource,
  updateLogData,
} from '@/redux/slices/logHistoricalReferral'
import { ReferralSource } from '@/types/misc'

interface Props {
  disabled: boolean
}

interface SourceOption {
  label: React.ReactNode
  icon: React.ReactNode
  value: ReferralSource
}

const SelectReferralSource: React.FC<Props> = () => {
  const referralSource = useAppSelector(selectReferralSource)
  const dispatch = useAppDispatch()

  const options: SourceOption[] = [
    {
      label: 'Introducer / Firm',
      icon: <LuBuilding2 />,
      value: REFERRAL_SOURCE.INTRODUCER,
    },
    { label: 'Direct', icon: <LuGlobe />, value: REFERRAL_SOURCE.DIRECT },
  ]

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
      {options.map((option, index) => {
        const isSelected = option.value === referralSource

        return (
          <button
            key={index}
            className={cn(
              `flex flex-col gap-1.5 justify-center items-center
              transition-colors border border-border hover:bg-muted/50
              rounded-lg p-2.5 cursor-pointer group hover:border-primary`,
              { 'border-primary bg-primary/5': isSelected },
            )}
            onClick={() =>
              dispatch(
                updateLogData({
                  referralSource: option.value,
                }),
              )
            }
          >
            <div
              className={cn('text-[15px]', {
                'text-primary': isSelected,
              })}
            >
              {option.icon}
            </div>

            <span className="text-[11px] font-medium text-foreground block">
              {option.label}
            </span>
          </button>
        )
      })}
    </div>
  )
}

export default SelectReferralSource
